import { useEffect, useRef, useState } from 'react';
import { useSwrGetBilingInfoList } from '@hooks/useSwrApi/endpoints/company';

type BillingType = 'individual' | 'company';

export const useBillingDataHub = (
  locale: Locale,
  initialBillingType: BillingType,
) => {
  const [billingType, setBillingType] = useState<BillingType>(initialBillingType);

  // ✅ Destructure mutate from SWR
  const {
    data: billingData = [],
    isLoading: isLoadingBillingType,
    mutate: refetchBillingData,
  } = useSwrGetBilingInfoList({
    locale,
    type: billingType,
  });

  const [selectedBillingInfo, setSelectedBillingInfo] = useState<ApiSchema<'BillingDataRead'> | undefined>(undefined);
  const initializedRef = useRef<Record<BillingType, boolean>>({ individual: false, company: false });

  useEffect(() => {
    const alreadyInitialized = initializedRef.current[billingType];

    if (!alreadyInitialized && billingData.length > 0) {
      setSelectedBillingInfo(billingData[0]);
      initializedRef.current[billingType] = true;
    } else {
      setSelectedBillingInfo(undefined);
    }
  }, [billingType, billingData]);

  const selectBillingInfo = (item: ApiSchema<'BillingDataRead'>) => {
    if (!item) return;
    setSelectedBillingInfo(item);
  };

  const clearSelectedBillingInfo = () => {
    setSelectedBillingInfo(undefined);
  };

  return {
    billingType,
    setBillingType,
    billingData,
    isLoadingBillingType,
    selectedBillingInfo,
    selectBillingInfo,
    clearSelectedBillingInfo,
    refetchBillingData,
  };
};
